import React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import FormControl from '@mui/material/FormControl'

export const ReduxSwitchWrapper = styled((props) => <FormControl {...props} />)``

export const InnerWrapper = styled.div<{ reverse?: boolean; alignItems?: string; justifyContent?: string }>`
  align-items: ${({ alignItems }) => alignItems};
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent};

  ${({ reverse }) =>
    reverse &&
    css`
      flex-direction: row-reverse;
      justify-content: flex-end;
      left: -8px;
      position: relative;
    `};

  label {
    transform: none;
    font-size: 16px;
    margin: 0 !important;

    position: static;
    display: flex;
    align-items: center;

    svg {
      height: 16px !important;
      width: 16px !important;
    }
  }
`

export const LockIconContainer = styled.div`
  align-items: center;
  display: flex;
`
